import { Box, Step, StepLabel, Stepper, styled } from '@mui/material';
import { ActionStatus } from 'further-types/lp/action';
import { investment as rules } from 'further-ui/validations';
import api from 'lib/trpcClient';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Steps } from './shared/enums';

const Container = styled(Box)({
  width: '700px',
});

const stepLabels = {
  [Steps.CreateInvestment]: 'Create investment',
  [Steps.CompleteAllocation]: 'Complete allocation',
  [Steps.RevalueInvestments]: 'Revalue investments',
  [Steps.ApproveTransaction]: 'Approve transaction',
};

type FormStepsProps = {
  vehicleId: string;
  activeStep: Steps;
  setIncludeRevalueInvestmentsStep: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

const FormSteps: React.FC<FormStepsProps> = ({
  vehicleId,
  activeStep,
  setIncludeRevalueInvestmentsStep,
}) => {
  const { watch } = useFormContext<rules.CreateInvestmentFormValues>();

  const [investments] = api.lpInvestment.list.useSuspenseQuery({
    vehicleId,
    order: 'desc',
    orderBy: 'ledgerDate',
    page: 1,
    rowsPerPage: 10000,
  });

  const assetId = watch('assetId');
  const investmentId = watch('investmentId');
  const dealCompletionDate = watch('dealCompletionDate');

  const investmentExistsForAsset = investments.results?.some(
    (investment) =>
      investment.assetId === assetId &&
      investment.status === ActionStatus.Approved &&
      investment.id !== investmentId &&
      investment.dealCompletionDate.toUTCDate() <
        (dealCompletionDate?.toUTCDate() ?? new Date()),
  );

  useEffect(() => {
    setIncludeRevalueInvestmentsStep(investmentExistsForAsset ?? false);
  }, [investmentExistsForAsset, setIncludeRevalueInvestmentsStep]);

  const labels = Object.values(stepLabels).filter((stepLabel) =>
    !investmentExistsForAsset
      ? stepLabel !== stepLabels[Steps.RevalueInvestments]
      : true,
  );

  return (
    <Container>
      <Stepper activeStep={activeStep}>
        {labels.map((stepLabel) => (
          <Step key={stepLabel}>
            <StepLabel>{stepLabel}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Container>
  );
};

export default FormSteps;
